import React from 'react';
import { formatDistanceToNow, format, isToday, isYesterday, isThisWeek } from 'date-fns';

const TimeAgo = ({ date, showFull = false, className = '' }) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const getRelativeTime = () => {
    if (isToday(dateObj)) {
      return `Today at ${format(dateObj, 'h:mm a')}`;
    }
    if (isYesterday(dateObj)) {
      return `Yesterday at ${format(dateObj, 'h:mm a')}`;
    }
    if (isThisWeek(dateObj)) {
      return format(dateObj, "EEEE 'at' h:mm a");
    }
    return format(dateObj, "MMM d, yyyy 'at' h:mm a");
  };

  const getTimeAgo = () => {
    return formatDistanceToNow(dateObj, { addSuffix: true });
  };

  if (showFull) {
    return (
      <span className={`text-zinc-500 ${className}`}>
        {getRelativeTime()}
      </span>
    );
  }

  return (
    <span className={`text-zinc-500 ${className}`} title={getRelativeTime()}>
      {getTimeAgo()}
    </span>
  );
};

export default TimeAgo;
